import React from 'react'
import { Badge } from '@/shared/ui'

type AnalysisHeaderProps = {
  warningText?: string | null
}

export function AnalysisHeader({ warningText }: AnalysisHeaderProps) {
  const badgeText = String(warningText || '').trim()

  return (
    <div className="mb-6 flex items-center justify-between">
      <div className="space-y-1">
        <h1 className="text-2xl font-semibold">Analise do mercado Cripto</h1>
        <p className="text-sm text-foreground/70">
          Acompanhe as principais analises do mercado cripto feita por traders experientes
        </p>
        {badgeText ? (
          <Badge variant="soft" color="warning" className="mt-2 whitespace-normal">
            {badgeText}
          </Badge>
        ) : null}
      </div>
    </div>
  )
}
